// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gift_cards/get_gift_card.proto (package app.dealzy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { GiftCard } from "./common_pb.js";

/**
 * @generated from message app.dealzy.GetGiftCardRequest
 */
export class GetGiftCardRequest extends Message<GetGiftCardRequest> {
  /**
   * @generated from field: int64 brand_id = 1;
   */
  brandId = protoInt64.zero;

  constructor(data?: PartialMessage<GetGiftCardRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "app.dealzy.GetGiftCardRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGiftCardRequest {
    return new GetGiftCardRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGiftCardRequest {
    return new GetGiftCardRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGiftCardRequest {
    return new GetGiftCardRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGiftCardRequest | PlainMessage<GetGiftCardRequest> | undefined, b: GetGiftCardRequest | PlainMessage<GetGiftCardRequest> | undefined): boolean {
    return proto3.util.equals(GetGiftCardRequest, a, b);
  }
}

/**
 * @generated from message app.dealzy.GetGiftCardResponse
 */
export class GetGiftCardResponse extends Message<GetGiftCardResponse> {
  /**
   * @generated from field: app.dealzy.GiftCard gift_card = 1;
   */
  giftCard?: GiftCard;

  constructor(data?: PartialMessage<GetGiftCardResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "app.dealzy.GetGiftCardResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gift_card", kind: "message", T: GiftCard },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGiftCardResponse {
    return new GetGiftCardResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGiftCardResponse {
    return new GetGiftCardResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGiftCardResponse {
    return new GetGiftCardResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGiftCardResponse | PlainMessage<GetGiftCardResponse> | undefined, b: GetGiftCardResponse | PlainMessage<GetGiftCardResponse> | undefined): boolean {
    return proto3.util.equals(GetGiftCardResponse, a, b);
  }
}

